import React, { useEffect, useState } from 'react'
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
} from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import { POLICY_TYPE_ENUM } from 'src/utils/constants/BuyPolicyMotor'
import { getInsuranceProviderList } from 'src/services/buyPolicyMotorService'
import { getTokenForQrReport } from 'src/services/individualService'
import infoToolTip from 'src/assets/Buy_Policy_Images/infoToolTip.svg'
import LoadingModal from 'src/components/common/LoadingModal'
import CustomDatePicker from 'src/components/BuyPolicy/common/CustomDatePicker'
import { useDispatch } from 'react-redux'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { insuranceProvider, showNotificationMessage } from 'src/actions'
import {
  getFormControlErrorText,
  isFormControlError,
} from 'src/services/formHelperService'
import { addScroll, removeScroll } from 'src/utils/commonMethods'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import { PROVIDER_LIST } from 'src/utils/constants/BuyPolicy'

const ModelForm = ({ formOne }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [insuranceProviders, setInsuranceProviders] = useState()
  const [insuranceProviderName, setInsuranceProviderName] = useState('')
  const [thirdPartyProviderName, setThirdPartyProviderName] = useState('')

  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const token = response?.res?.data?.access_token
      fetchInsuranceProviderList(token)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const fetchInsuranceProviderList = async (token) => {
    setLoading(true)
    const response = await getInsuranceProviderList(token)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData) {
        setInsuranceProviders(responseData)
        dispatch(insuranceProvider(responseData))
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: PROVIDER_LIST,
        })
      )
    }
  }
  const handleProviderChange = (event, value) => {
    formOne.setFieldValue(
      'previousPolicyProvider',
      value?.insuranceCompanyName,
      true
    )
    formOne.setFieldValue(
      'previousPolicyProviderFirstName',
      value?.insuranceCompanyFirstName,
      true
    )
  }
  const handleThirdPartyChange = (event, value) => {
    formOne.setFieldValue(
      'thirdPartyProvider',
      value?.insuranceCompanyName,
      true
    )
    formOne.setFieldValue(
      'thirdPartyProviderFirstName',
      value?.insuranceCompanyFirstName,
      true
    )
  }
  useEffect(() => {
    fetchToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box>
      <LoadingModal loading={loading} />
      <form>
        <Box className={classes.containerMain}>
          <Box className={classes.containerSection}>
            <Box className={classes.containerSectionHeading}>
              Please fill your details
            </Box>
            <Box className={classes.containerSectionRow}>
              <Box className={classes.containerSectionRow}>
                <Box>
                  <FormControl size='small'>
                    <TextField
                      id='Name'
                      name='name'
                      size='small'
                      placeholder='Name *'
                      onBlur={formOne.handleBlur}
                      onChange={formOne.handleChange}
                      value={formOne?.values?.name}
                      helperText={getFormControlErrorText(formOne, 'name')}
                      error={isFormControlError(formOne, 'name')}
                      InputProps={{
                        className: classes.inputWidth,
                      }}
                    />
                  </FormControl>
                </Box>
                <Box>
                  <TextField
                    id='mobileNumber'
                    name='mobileNumber'
                    size='small'
                    type='number'
                    placeholder='Mobile Number *'
                    onBlur={formOne.handleBlur}
                    onChange={(event) => {
                      event.target.value = Math.max(
                        0,
                        parseInt(event?.target?.value)
                      )
                        ?.toString()
                        ?.slice(0, 10)
                      formOne.handleChange(event)
                    }}
                    value={formOne.values.mobileNumber}
                    helperText={getFormControlErrorText(
                      formOne,
                      'mobileNumber'
                    )}
                    error={isFormControlError(formOne, 'mobileNumber')}
                    InputProps={{
                      className: classes.inputWidth,
                    }}
                  />
                </Box>
                <Box>
                  <TextField
                    id='Email'
                    name='email'
                    size='small'
                    placeholder='Email(optional)'
                    onBlur={formOne.handleBlur}
                    onChange={formOne.handleChange}
                    value={formOne?.values?.email}
                    helperText={getFormControlErrorText(formOne, 'email')}
                    error={isFormControlError(formOne, 'email')}
                    InputProps={{
                      className: classes.inputWidth,
                    }}
                  />
                </Box>
              </Box>
              <Box
                display={'flex'}
                flexDirection={'column'}
                justifyContent={'space-between'}
                alignItems={'center'}
                marginTop={'-10px'}
              >
                <Box className={classes.checkBoxSection}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formOne?.values?.isCompany}
                          onChange={(event) => {
                            formOne.setFieldValue(
                              'isCompany',
                              event?.target?.checked
                            )
                          }}
                          size='small'
                        />
                      }
                      label={
                        <Box className={classes.checkBoxLabel}>
                          Is the vehicle registered under the company name?
                        </Box>
                      }
                    />
                  </FormGroup>
                </Box>
                {formOne?.values?.isCompany ? (
                  <Box>
                    <TextField
                      id='Company'
                      name='companyName'
                      size='small'
                      placeholder='Company Name *'
                      onBlur={formOne.handleBlur}
                      onChange={formOne.handleChange}
                      value={formOne?.values?.companyName}
                      helperText={getFormControlErrorText(
                        formOne,
                        'companyName'
                      )}
                      error={isFormControlError(formOne, 'companyName')}
                      InputProps={{
                        className: classes.inputWidth,
                      }}
                    />
                  </Box>
                ) : null}
              </Box>
            </Box>
          </Box>
          <Box className={classes.containerSection}>
            <Box className={classes.containerSectionHeading}>
              Previous policy provider
            </Box>
            <Box className={classes.containerSectionRow}>
              <Box>
                <FormControl size='small'>
                  <Autocomplete
                    id='previousPolicyProvider'
                    name='previousPolicyProvider'
                    disableClearable
                    options={insuranceProviders ? insuranceProviders : []}
                    getOptionLabel={(option) =>
                      option.insuranceCompanyName ||
                      formOne?.values?.previousPolicyProvider ||
                      ''
                    }
                    value={formOne?.values?.previousPolicyProvider || ''}
                    inputValue={insuranceProviderName}
                    onInputChange={(event, newInputValue) => {
                      setInsuranceProviderName(newInputValue)
                    }}
                    onChange={(event, newInsuranceName) => {
                      handleProviderChange(event, newInsuranceName)
                    }}
                    className={`${classes.selectWidth}`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={'Select Previous Provider *'}
                        variant='outlined'
                        size='small'
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'new-password',
                          className: classes.autoStyle,
                        }}
                      />
                    )}
                    onOpen={() => {
                      removeScroll()
                    }}
                    onClose={() => {
                      addScroll()
                    }}
                  />

                  {isFormControlError(formOne, 'previousPolicyProvider') ? (
                    <FormHelperText className={classes.errorStyle}>
                      {getFormControlErrorText(
                        formOne,
                        'previousPolicyProvider'
                      )}
                    </FormHelperText>
                  ) : null}
                </FormControl>
              </Box>
            </Box>
          </Box>
          <Box className={classes.containerSection}>
            <Box className={classes.containerSectionHeading}>
              Previous policy number
            </Box>
            <Box className={classes.containerSectionRow}>
              <Box>
                <TextField
                  id='previousPolicyNumber'
                  name='previousPolicyNumber'
                  size='small'
                  placeholder='Policy Number *'
                  onBlur={formOne.handleBlur}
                  onChange={formOne.handleChange}
                  value={formOne?.values?.previousPolicyNumber}
                  helperText={getFormControlErrorText(
                    formOne,
                    'previousPolicyNumber'
                  )}
                  error={isFormControlError(formOne, 'previousPolicyNumber')}
                  InputProps={{
                    className: classes.inputWidth,
                  }}
                />
              </Box>
            </Box>
          </Box>
          <Box className={classes.containerSection}>
            <FormControl>
              <FormLabel
                id='motor-buttons-policy-label'
                className={classes.containerSectionHeading}
              >
                What policy type do you want to buy?
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby='motor-radio-buttons-policy-label'
                name='motor-buttons-policy'
                value={formOne.values.policyType}
                onChange={(e) => {
                  formOne.setFieldValue('policyType', e?.target?.value, true)
                }}
              >
                <FormControlLabel
                  value={POLICY_TYPE_ENUM.OWN_DAMAGE}
                  control={<Radio size='small' />}
                  label={
                    <Box className={classes.RadioBtnText}>
                      Own Damage
                      <Tooltip
                        title={
                          <>
                            <Box>
                              Should be chosen <b>if Third-Party is active</b>
                            </Box>
                          </>
                        }
                      >
                        <img
                          src={infoToolTip}
                          alt={infoToolTip}
                          className={classes.infoImage}
                        />
                      </Tooltip>
                    </Box>
                  }
                />
                <FormControlLabel
                  className={classes.formRadioText}
                  value={POLICY_TYPE_ENUM?.COMPREHENSIVE}
                  control={<Radio size='small' />}
                  label={
                    <Box className={classes.RadioBtnText}>
                      Comprehensive
                      <Tooltip
                        title={
                          <>
                            <Box>
                              Covers <b>both</b> you and others
                            </Box>
                          </>
                        }
                      >
                        <img
                          src={infoToolTip}
                          alt={infoToolTip}
                          className={classes.infoImage}
                        />
                      </Tooltip>
                    </Box>
                  }
                />
                <FormControlLabel
                  className={classes.formRadioText}
                  value={POLICY_TYPE_ENUM?.THIRD_PARTY}
                  control={<Radio size='small' />}
                  label={
                    <Box className={classes.RadioBtnText}>
                      Third Party
                      <Tooltip
                        title={
                          <>
                            <Box>
                              Covers damage to <b>others only</b>
                            </Box>
                          </>
                        }
                      >
                        <img
                          src={infoToolTip}
                          alt={infoToolTip}
                          className={classes.infoImage}
                        />
                      </Tooltip>
                    </Box>
                  }
                />
              </RadioGroup>
              {isFormControlError(formOne, 'policyType') ? (
                <FormHelperText className={classes.errorStyle}>
                  {getFormControlErrorText(formOne, 'policyType')}
                </FormHelperText>
              ) : null}
            </FormControl>
            {formOne?.values?.policyType === POLICY_TYPE_ENUM?.OWN_DAMAGE && (
              <>
                <Box className={classes.ownDamageFieldsMainContainer}>
                  <Box className={classes.ownDamageFieldsContainer}>
                    <Box className={classes.ownDamageFieldsSubContainer}>
                      <Box className={classes.containerSectionHeading}>
                        What is your third party start date?
                      </Box>
                      <Box>
                        <CustomDatePicker
                          id='thirdPartyStartDate'
                          name='thirdPartyStartDate'
                          placeholder='Third Party Start Date *'
                          value={formOne?.values?.thirdPartyStartDate}
                          onChange={formOne.handleChange}
                          className={`${classes.thirdPartyDateWidth} ${classes.thirdParty}`}
                          helperText={getFormControlErrorText(
                            formOne,
                            'thirdPartyStartDate'
                          )}
                          error={isFormControlError(
                            formOne,
                            'thirdPartyStartDate'
                          )}
                        />
                      </Box>
                    </Box>

                    <Box className={classes.ownDamageFieldsSubContainer}>
                      <Box className={classes.containerSectionHeading}>
                        When does your third party expire?
                      </Box>
                      <Box>
                        <CustomDatePicker
                          id='thirdPartyExpiryDate'
                          name='thirdPartyExpiryDate'
                          placeholder='Third Party Expiry Date *'
                          value={formOne?.values?.thirdPartyExpiryDate}
                          onChange={formOne.handleChange}
                          className={`${classes.thirdPartyDateWidth} ${classes.thirdParty}`}
                          helperText={getFormControlErrorText(
                            formOne,
                            'thirdPartyExpiryDate'
                          )}
                          error={isFormControlError(
                            formOne,
                            'thirdPartyExpiryDate'
                          )}
                        />
                      </Box>
                    </Box>
                  </Box>
                  <Box className={classes.ownDamageFieldsContainer}>
                    <Box className={classes.ownDamageFieldsSubContainer}>
                      <Box className={classes.containerSectionHeading}>
                        What is your third party insurer name
                      </Box>
                      <Box>
                        <Autocomplete
                          id='thirdPartyPolicyProvider'
                          name='thirdPartyPolicyProvider'
                          disableClearable
                          options={insuranceProviders ? insuranceProviders : []}
                          getOptionLabel={(option) =>
                            option.insuranceCompanyName ||
                            formOne.values.thirdPartyProvider ||
                            ''
                          }
                          value={formOne?.values?.thirdPartyProvider || ''}
                          inputValue={thirdPartyProviderName}
                          onInputChange={(event, newInputValue) => {
                            setThirdPartyProviderName(newInputValue)
                          }}
                          onChange={(event, newInsuranceName) => {
                            handleThirdPartyChange(event, newInsuranceName)
                          }}
                          className={`${classes.selectWidth} ${classes.thirdPartyProv}`}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={'Select third party provider *'}
                              variant='outlined'
                              helperText={getFormControlErrorText(
                                formOne,
                                'thirdPartyProvider'
                              )}
                              error={isFormControlError(
                                formOne,
                                'thirdPartyProvider'
                              )}
                            />
                          )}
                          onOpen={() => {
                            removeScroll()
                          }}
                          onClose={() => {
                            addScroll()
                          }}
                        />
                      </Box>
                    </Box>
                    <Box className={classes.ownDamageFieldsSubContainer}>
                      <Box className={classes.containerSectionHeading}>
                        What is your third party policy number
                      </Box>
                      <Box>
                        <TextField
                          id='thirdPartyPolicyNo'
                          name='thirdPartyPolicyNo'
                          size='small'
                          placeholder='Policy Number *'
                          onBlur={formOne.handleBlur}
                          onChange={formOne.handleChange}
                          value={formOne?.values?.thirdPartyPolicyNo}
                          helperText={getFormControlErrorText(
                            formOne,
                            'thirdPartyPolicyNo'
                          )}
                          error={isFormControlError(
                            formOne,
                            'thirdPartyPolicyNo'
                          )}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </>
            )}
          </Box>
        </Box>
      </form>
      <Box className={classes.nextBtnContainer}>
        <Button
          variant='contained'
          className={classes.nextBtn}
          type='submit'
          onClick={() => {
            formOne.submitForm()
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  )
}

export default ModelForm

const useStyles = makeStyles({
  containerMain: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: '12px',
    gap: 10,
    paddingLeft: 30,
  },
  containerSectionColumn: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
  },
  containerSectionRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  thirdParty: {
    '&  .MuiOutlinedInput-input': {
      height: '0.2rem',
    },
  },
  thirdPartyProv: {
    '& .MuiIconButton-root': {
      padding: 'unset',
    },
    '& .MuiOutlinedInput-root': {
      padding: 'unset',
    },
  },
  previousPolicy: {
    '& .MuiIconButton-root': {
      padding: 'unset',
    },
    '& .MuiOutlinedInput-root': {
      display: 'flex',
      justifyContent: 'space-between',
      padding: 'unset',
    },
  },
  containerSection: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    gap: 10,
    paddingBottom: 10,
  },
  containerSectionTwo: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    gap: 10,
    paddingBottom: 10,
  },
  containerSectionThree: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    gap: 10,
    paddingBottom: 10,
  },
  containerSectionHeading: {
    fontFamily: 'Roboto',
    fontSize: '15px',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0em',
    color: '#000000',
    padding: '10px',
  },
  checkBoxLabel: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14px',
    letterSpacing: '0em',
    color: '#484848',
    marginLeft: '-8px',
  },
  RadioBtnText: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '15px',
    letterSpacing: '0em',
    marginLeft: '-8px',
  },
  nextBtn: {
    background: 'linear-gradient(180deg, #4DC3E3 0%, #1EA0C4 100%)',
  },
  nextBtnContainer: {
    paddingLeft: 30,
  },
  errorStyle: { color: 'red !important ' },
  inputWidth: {
    maxWidth: 160,
    fontSize: '12px !important',
  },
  selectWidth: {
    minWidth: 200,
    fontSize: '12px !important',
  },
  checkBoxSection: {},
  infoImage: { paddingLeft: '2px', marginBottom: '-2px' },
  autoStyle: {
    fontSize: '12px !important',
    height: '2px !important',
    color: 'black',
    padding: 'unset ',
  },
  thirdPartyDateWidth: {
    maxWidth: 230,
    fontSize: '12px !important',
  },

  ownDamageFieldsMainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  ownDamageFieldsContainer: {
    display: 'flex',
    flex: '1',
    flexDirection: 'row',
    gap: '5%',
    alignItems: 'flex-start',
    '@media (max-width: 1000px)': {
      flexDirection: 'column',
      gap: '10px',
    },
  },
  ownDamageFieldsSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    flexWrap: 'wrap',
  },
  thirdPartyTextFields: {
    maxWidth: 230,
    fontSize: '12px !important',
  },
})
